import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { BiddingFinalConfirmationComponent } from '../bidding-final-confirmation/bidding-final-confirmation.component';
import { FormControl, FormGroup } from '@angular/forms';
import { FileUploadValidators } from '@iplab/ngx-file-upload';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from 'src/app/utils/loader.service';
import { AdminService } from 'src/app/admin/admin.service';

interface DialogData {
  termsData: any
}

@Component({
  selector: 'app-review-bidding',
  templateUrl: './review-bidding.component.html',
  styleUrls: ['./review-bidding.component.scss']
})

export class ReviewBiddingComponent implements OnInit {
  rfqData: any;
  vendorItems;
  currency: string = '';
  private filesControl = new FormControl(null, FileUploadValidators.filesLimit(15));
  public uploadFileForm = new FormGroup({
    files: this.filesControl
  });
  file_report_uploaded: boolean;
  qualityReports = [];
  supporteduploadFileFormFiletypes: Array<string> = ['pdf', 'xls', 'xlsx'];
  id: any;
  enquiryId: any

  constructor(
    public dialogref: MatDialogRef<ReviewBiddingComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private router: Router,
    private toastr: ToastrService,
    public loaderService: LoaderService,
    private adminService: AdminService,
  ) { }

  ngOnInit() {
    this.id = this.data['id']
    this.enquiryId = this.data['enquiryId']
    this.rfqData = this.data["data"]
    this.currency = this.data['currency'];
    this.vendorItems = this.rfqData.vendor_bid_items
    // this.currency = this.rfqData.currency;
    this.uploadFileFormFiles()
  }

  close() {
    this.dialogref.close();
  }
  continue() {
    this.uploadFile();
    // this.close();

    // const dialogRef = this.dialog.open(BiddingFinalConfirmationComponent, {
    //   panelClass: 'my-panel',
    //   disableClose: true,
    //   data: { data: this.rfqData.id }
    // });

    // dialogRef.afterClosed().subscribe(
    //   res => {
    //     this.router.navigate(['/admin/rfq'])
    //   }
    // )
  }

  uploadFileFormFiles() {
    const uploadFile = this.uploadFileForm.get('files')
    uploadFile.valueChanges.subscribe(
      (res: any) => {
        if (res == null || res.length == 0) {
          this.file_report_uploaded = false;
        }
        else {
          for (var i = 0; i < res.length; i++) {
            this.qualityReports.push(res[i]);
            let allSplits = (res[i].name).split('.');
            let type = allSplits[allSplits.length - 1];
            if (!this.supporteduploadFileFormFiletypes.includes(type)) {
              this.toastr.error('Upload file type not supported', 'Error');
              setTimeout(() => {
                this.uploadFileForm.get('files').setValue([]);
              }, 500);
              this.qualityReports = [];
            }
            this.file_report_uploaded = true;
          }
        }
      },
      err => {
        this.toastr.error('Error Uploading File', 'Error');
      }
    )
  }

  uploadFile() {
    let formData = new FormData();
    if (this.qualityReports.length > 0) {
      this.loaderService.display(true);
      for (var i = 0; i < this.qualityReports.length; i++) {
        formData.append('costing_files', this.qualityReports[0])
      }
      formData.append('enquiryId', this.enquiryId)
      this.adminService.uploadFiles(this.id, formData).subscribe(
        (res: any) => {
          if (res?.status == 200) {
            this.toastr.success('File Uploaded Successfully', 'success');
            this.loaderService.display(false);
            this.close();
          } else {
            this.toastr.error('Please check your files', 'Error!')
            this.loaderService.display(false);
          }

          this.submitBid();
        },
        err => {
          this.toastr.error('Something went wrong', 'Error');
          this.loaderService.display(false);
        }
      )
    } else {
      // this.toastr.error('Please Upload files', 'Error!')
      this.submitBid()
    }
  }

  private submitBid(){
    const dialogRef2 = this.dialog.open(BiddingFinalConfirmationComponent, {
      panelClass: 'my-panel',
      disableClose: true,
      data: { data: this.rfqData.id, termsData: this.data.termsData }
    });

    dialogRef2.afterClosed().subscribe(
      res => {
        if (res) {
          this.close()
          this.router.navigate(['/admin/rfq'])
        }

      }
    )
  }

  deleteQualityReport(index) {
    this.qualityReports.splice(index, 1)
    if (typeof this.qualityReports !== 'undefined' && this.qualityReports?.length > 0) {
    } else {
      this.file_report_uploaded = false;
      this.qualityReports = [];
      this.uploadFileForm.reset();
      this.uploadFileForm.reset(this.uploadFileForm.value);
      this.uploadFileForm.clearValidators();
    }
  }

}
